import {
  GET_PROFILE,
  PROFILE_LOADING,
  PROFILES_LOADING,
  CLEAR_CURRENT_PROFILE,
  GET_PROFILES,
  DELETE_PROFILE
} from '../actions/types';

const initialState = {
  profile: {},
  profiles: [],
  
  loading: false,
  deletedprofile: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case PROFILE_LOADING:
      return {
        ...state,
        loading: true
      };
    case PROFILES_LOADING:
      return {
        ...state,
        loading: true
      };
    case GET_PROFILES:
      return {
        ...state,
        profiles: action.payload,
        loading: false
      };
    case GET_PROFILE:
      return {
        ...state,
        profile: action.payload,
        loading: false
      };
    case CLEAR_CURRENT_PROFILE:
      return {
        ...state,
        profile: null
      };
    case DELETE_PROFILE:
      return {
        ...state,
        profiles: state.profiles.filter(profile => profile._id !== action.payload)
      };
    default:
      return state;
  }
}
